<template>
  <Modal
    v-model="_value"
    width="600"
    title="分析结果处理"
    @on-visible-change="visibleChange"
    ok-text="确认处理"
    @on-ok="onOk"
    cancel-text="关闭">
    <Form :model="remind" style="display: inline;">
      <FormItem prop="processState">
        <label style="display: inline-block; width: 100px;">处理状态</label>
        <Select style="display: inline-block; width: 200px;"
                v-model="selectProcessState">
          <Option v-for="item in processState" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="processRemark">
        <label style="display: inline-block; width: 100px;">历史备注</label>
        <Input disabled style="display: inline-block; width: 400px;" type="textarea" v-model="remind.processRemark"
               placeholder="历史分析结果备注">
        </Input>
      </FormItem>
      <FormItem prop="processRemark">
        <label style="display: inline-block; width: 100px;">处理备注</label>
        <Input style="display: inline-block; width: 400px;" type="textarea" v-model="addRemark"
               placeholder="处理备注">
        </Input>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'processremindmodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      processState: [
        { label: '正在跟进', value: 1 },
        { label: '已处理', value: 2 }
      ],
      addRemark: null,
      selectProcessState: 1,
      remind: {
        id: null,
        processState: 1,
        processRemark: null
      }
    }
  },
  methods: {
    ...mapActions([
      'AlarmAnalysisServ_ModifyObj',
      'AlarmAnalysisServ_GetDetail'
    ]),
    onOk () {
      console.log('onOk')
      this.$Modal.confirm({
        title: '提示',
        content: '<p>确认处理</p>',
        onOk: () => {
          store.dispatch('RemindServ_ProcessRemind', {
            params: {
              id: this.remind.id,
              processState: this.selectProcessState,
              remark: this.addRemark
            }
          }).then(() => {
            this.$Message.success('追加成功')
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {

        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.remind.id = null
        this.remind.processState = 1
        this.remind.processRemark = null
        this.selectProcessState = 1
        this.addRemark = null
        console.log(this._initValue)
        store.dispatch('RemindServ_GetDetail', {
          params: { id: this._initValue }
        }).then(() => {
          this.remind = store.getters.get_Remind_GetDetailResult
        }).catch(err => {
          this.$Message.error(err)
        })
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
